import React from 'react';
import s from './Ribbon.scss';
import {RibbonPlacementId} from '../../../../types/galleryTypes';
import classNames from 'classnames';
import {withTranslations} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {withGlobals} from '../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../../gallery/galleryGlobalStrategy';
import {Experiments} from '../../../../constants';

export enum RibbonDataHook {
  RibbonOnImage = 'RibbonDataHook.RibbonOnImage',
  RibbonOnProductInfo = 'RibbonDataHook.RibbonOnProductInfo',
}

export interface IRibbonProps extends IGalleryGlobalProps {
  ribbon: string;
  placement: RibbonPlacementId;
  shouldShowMobile: boolean;
}

class RibbonComp extends React.Component<IRibbonProps> {
  public render() {
    const {ribbon, placement, shouldShowMobile, globals} = this.props;
    const dataHook =
      placement === RibbonPlacementId.OnImage ? RibbonDataHook.RibbonOnImage : RibbonDataHook.RibbonOnProductInfo;
    const {useExperiments} = globals;
    const isShowWishlistInGalleryEnabled = useExperiments.enabled(Experiments.ShowWishlistInGallery);
    const isShowMultiRibbonsInGalleryEnabled = useExperiments.enabled(Experiments.ShowMultiRibbonsInGallery);

    return (
      <div
        className={classNames(
          s.ribbon,
          {[s.onImage]: placement === RibbonPlacementId.OnImage},
          {[s.oldProductInfo]: placement === RibbonPlacementId.ProductInfo && !isShowMultiRibbonsInGalleryEnabled},
          {[s.productInfo]: placement === RibbonPlacementId.ProductInfo && isShowMultiRibbonsInGalleryEnabled},
          {[s.mobile]: shouldShowMobile},
          {[s.NoFlexOverlayContainer]: placement === RibbonPlacementId.OnImage && !isShowWishlistInGalleryEnabled}
        )}
        data-hook={dataHook}>
        {ribbon}
      </div>
    );
  }
}

export const ProductRibbon = withGlobals(withTranslations()(RibbonComp));
